<!--  -->
<template>
  <div>
    <div id="cont">
      <div class="cont">
        <div class="cont_l">
          <div class="cont_l_01">
            <div class="cont_l_02">
              <img :src="images.tzj_03">
            </div>
            <div class="cont_l_03">
              <ul class="lit01">
                <li class="lit01_c">
                  <router-link to="/investew" class="lit01_b">{{text.invest1}}</router-link>
                </li>
              </ul>
            </div>
            <div class="cont_l_04"></div>
          </div>
        </div>
        <div class="cont_r">
          <div class="cont_r_t">
            <div class="cont_r_t01">
              <span>{{text.profile3}}</span>
              <span>：</span>
              <span>{{text.profile4}}</span>
              <span>-</span>
              <span>{{text.invest1}}</span>
            </div>
          </div>
          <div class="cont_r_b">
            <div id="rightdiv">
              <router-view></router-view>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        tzj_03: require("../../../assets/img/ew/tzj_03.jpg")
      },
      text: {
        profile3: "",
        profile4: "Главная страница",
        invest1: "Инвестиция"
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/invest/invest.vue